var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnselectedTopFloor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 41,
    viewBox: "0 0 84 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 14L43 1L83.5 14V27L43 40L1 27V14Z",
    fill: "#EDE3F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 14L43 1L83.5 14M1 14L43 26.5M1 14V27L43 40M83.5 14L43 26.5M83.5 14V27L43 40M43 26.5V40",
    stroke: "#C688EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnselectedTopFloor);
export default __webpack_public_path__ + "static/media/unselected-top-floor.ebdd2e9ae55aa9316930efa725e5bb52.svg";
export { ForwardRef as ReactComponent };